import axios from 'axios'

const BASE_PATH = 'cooked-weights/'

export default {
  groups (date) {
    return axios.get(BASE_PATH + date + '/groups')
  },
  storeRealWeight (date, mealId, subgroupId, grams) {
    return axios.post(BASE_PATH + date + '/real', {
      meal_id: mealId,
      subgroup_id: subgroupId,
      real_weight_grams: grams
    })
  }
}
